<template>
  <div>
    <exp-header :items="this.$host.items"></exp-header>
    <div class="pdf">
      <template v-if="show">
        <div class="show" @click="goBack">
          <img src="../../../assets/images/icon_back_s.png" alt>
          <span>PC端</span>
        </div>
      </template>
      <template v-else>
        <div class="show" @click="goBack">
          <img src="../../../assets/images/icon_back_s.png" alt>
          <span>APP端</span>
        </div>
      </template>
      <div class="title-detail">{{name}}=>操作手册</div>
      <div class="pdf-detail">
        <pdf
          :src="src"
          :page="currentPage"
          @num-pages="pageCount = $event"
          @page-loaded="currentPage = $event"
        ></pdf>
      </div>
      <p class="footer-paging">
        <span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</span>
        {{currentPage}} / {{pageCount}}
        <span
          @click="changePdfPage(1)"
          class="turn"
          :class="{grey: currentPage==pageCount}"
        >下一页</span>
      </p>
    </div>
    <Footer/>
  </div>
</template>

<script>
import ExpHeader from "./components/exp-header";
import Footer from "../footer/app-footer";

import pdf from "vue-pdf";
export default {
  components: {
    pdf,
    ExpHeader,
    Footer
  },
  name: "index",
  data() {
    return {
      back_logo: false,
      src: this.$route.query.url,
      id: this.$route.query.id,
      currentPage: 0,
      pageCount: 0,
      name: this.$route.query.name,
      // this.$route.query.url.match(/[\u4e00-\u9fa5]/g).join("")
      show: true
    };
  },
  created() {
    let id = this.$route.query.id;
    if (id == 1) {
      this.show = true;
    } else if (id == 2) {
      this.show = true;
    } else {
      this.show = false;
    }
  },
  mounted() {
    const u = navigator.userAgent;
    // const app = navigator.appVersion
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isAndroid != true && isIOS != true) {
      this.back_logo = false;
    } else {
      this.back_logo = true;
    }
    this.currentPage = 1;
    this.src = pdf.createLoadingTask(this.src);
    //    alert(this.$route.params.url)
  },
  methods: {
    changePdfPage(val) {
      //翻页
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    goBack () {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.pdf {
  padding: 5%;
}
.title-detail {
  font-weight: bold;
  padding: 5% 0 3%;
  text-align: center;
  font-size: 20px;
}
.pdf-detail {
  box-shadow: 0px 0px 2px #000;
}
.footer-paging {
  text-align: right;
  text-align: -webkit-right;
  padding-top: 5%;
  padding-right: 13%;
  font-size: 20px;
  color: #333;
}
.turn {
  font-size: 20px;
  cursor: pointer;
}
.show {
  font-size: 16px;
  color: #999;
  padding: 60px 15px 0 120px;
  cursor: pointer;
  display: flex !important;
  align-items: center;
}
.show img {
  width: 28px;
  height: 26px;
}
.show span {
  color: #333;
  padding-left: 5px;
}
</style>
